// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2T7C7","column":"style_column__27cRV","row":"style_row__2sDJL"};